import request from '@/utils/request'

export function getRoomDiagramApi(query) {
  return request({
    url: '/chamber-service/v1/room-diagram',
    method: 'get',
    params: query
  })
}

export function getRoomDiagramHouseKeepingApi(query) {
  return request({
    url: '/chamber-service/v1/room-diagram/housekeeping',
    method: 'get',
    params: query
  })
}
